"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _animejs = _interopRequireDefault(require("animejs"));

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _getDebugInfo = _interopRequireDefault(require("../utils/getDebugInfo"));

require("../styles/_context-menu.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function showIcon(iconClass) {
  return function () {
    (0, _animejs.default)({
      targets: iconClass,
      opacity: [{
        value: 1,
        duration: 1000
      }, {
        value: 0,
        duration: 1000
      }],
      autoplay: true,
      easing: 'easeOutElastic(1, .8)',
      loop: false
    });
  };
}

function ContextMenu(_ref) {
  var coordinates = _ref.coordinates,
      toggleLoop = _ref.toggleLoop,
      loop = _ref.loop;

  if (!coordinates) {
    return null;
  }

  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "context-menu",
      style: {
        left: coordinates.x,
        top: coordinates.y
      }
    }, /*#__PURE__*/_react.default.createElement(_reactCopyToClipboard.CopyToClipboard, {
      text: window.location.href,
      onCopy: showIcon('.player__link-copied')
    }, /*#__PURE__*/_react.default.createElement("p", null, "Copy video URL")), /*#__PURE__*/_react.default.createElement("div", {
      role: "button",
      onKeyPress: (0, _onEnterPressed.default)({
        onClick: toggleLoop
      }),
      onClick: toggleLoop,
      tabIndex: 0
    }, "Loop", loop ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      color: "white",
      size: 12,
      name: "success"
    }) : null), /*#__PURE__*/_react.default.createElement(_reactCopyToClipboard.CopyToClipboard, {
      text: (0, _getDebugInfo.default)(),
      onCopy: showIcon('.player__link-debug-copied')
    }, /*#__PURE__*/_react.default.createElement("p", null, "Copy debug info")))
  );
}

var _default = (0, _react.memo)(ContextMenu);

exports.default = _default;